import { Component, OnInit, Inject } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {BaseComponent, CommonService} from '@rubii/frontend-common';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfigService} from "../services/config.service";
import {ItemResponse} from "@rubii/frontend-common/lib/models/common/Response";
import { ClientService } from '../services/client.service';

@Component({
    selector: 'app-activate',
    templateUrl: './activate.component.html',
    styleUrls: ['./activate.component.scss']
})
export class ActivateComponent extends BaseComponent implements OnInit {

    sent = false;
    activateForm: FormGroup;
    token: string;


    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private client: ClientService, private config: ConfigService, private snackBar: MatSnackBar) {
        super();
        this.token = data.token;
        this.activateForm = new FormGroup({
            password: new FormControl('', [
                Validators.required,
                Validators.pattern(/\d+/),
                Validators.pattern(/[a-z]+/),
                Validators.pattern(/[A-Z]+/),
                Validators.minLength(8)
            ]),
            repeat: new FormControl('', [
                Validators.required,
                Validators.pattern(/\d+/),
                Validators.pattern(/[a-z]+/),
                Validators.pattern(/[A-Z]+/),
                Validators.minLength(8)
            ])
        }, { validators: this.validatePassword});

    }

    validatePassword(control: FormGroup) {
        if (control.get('password').value === control.get('repeat').value) {
            return null;
        } else {
            return { invalid: true };
        }
    }

    ngOnInit() {
    }

    activate() {
        if (!this.activateForm.valid) {
            return ;
        }
        let input = {token: this.token, password: this.activateForm.get('password').value, confirmPassword: this.activateForm.get('repeat').value};
        this.client.user.activate(input).then(res => this.activateCallback({result: true, data: res} as ItemResponse)).catch(e => this.activateCallback({result: false, text: e.message} as ItemResponse));
    }

    activateCallback(response: ItemResponse) {
        if (response.result) {
            this.sent = true;
        } else {
            this.openSnackBarWarning(this.snackBar, response.text, "x");
        }
    }

}
